import _                                               from 'underscore';
import React                                           from 'react';
import { Align, CorvalUIColor }                        from "@src/types";
import { Icon }                                        from "semantic-ui-react";
import { CorvalAssistantMagicContainer }               from "@src/views/components/product/CorvalAssistantMagicContainer";
import { runIfFunction }                               from "@src/util";
import { useSystemModals }                             from "@src/hooks";
import { CorvalAssistantBasicHelpDecisionPointDialog } from "@src/views/pages/projects/CorvalAssistantBasicHelpDecisionPointDialog";


interface CorvalAssistantIconLinkProps {
    onClick?: () => void | undefined,
}

const CorvalAssistantIconLinkDefaultProps = {
    onClick: undefined,
} satisfies Partial<CorvalAssistantIconLinkProps>

function CorvalAssistantIconLink( _props: CorvalAssistantIconLinkProps ){

    const props = { ...CorvalAssistantIconLinkDefaultProps, ..._props };

    const modalActions = useSystemModals();

    const handleCorvalAssistantClicked = () => {

        if( _.isFunction( props.onClick ) ){

            runIfFunction( props.onClick );

        } else {

            modalActions.show(
                <CorvalAssistantBasicHelpDecisionPointDialog
                    innerContainerOnly={ true }
                    isOpen={ true }
                    dialogProps={ {
                        onComplete: handleGuidanceModalComplete,
                        onClose:    handleGuidanceModalClosed,
                    } }
                />
            );
        }
    }

    const handleGuidanceModalComplete = ( data ) => {

        const { selectedType } = data;

        modalActions.toggle( false );
    }

    const handleGuidanceModalClosed = () => {

        modalActions.toggle( false );
    }

    return (
        <CorvalAssistantMagicContainer
            onClick={ handleCorvalAssistantClicked }
            textColor={ CorvalUIColor.WHITE }
            textAlign={ Align.CENTER }
            className={ `cursor--pointer opacity--90 opacity-hover--100 display--grid flexbox--justify-center flexbox--align-center hide--below-md` }
            style={ { borderRadius: 20, width: 40, height: 40 } }>

            <Icon name={ 'compass' } fitted size={ 'large' }/>

        </CorvalAssistantMagicContainer>
    );
}

export {
    CorvalAssistantIconLink,
    CorvalAssistantIconLinkDefaultProps,
    type CorvalAssistantIconLinkProps,
};
